import DatePicker from 'react-datepicker';
import React, { useState } from 'react';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import PropTypes from 'prop-types';
import InfoTooltip from '../shared/InfoTooltip';

const FunnelDateSelector = ({ date, setDate, loading }) => {
  const [option, setOption] = useState(date ? 'date' : 'total');

  return (
    <div className="funnel-report-date-filter">
      <label htmlFor="date-option1">
        <input
          id="date-option1"
          type="radio"
          name="option"
          value="total"
          checked={option === 'total'}
          onClick={() => {
            setOption('total');
            setDate(null);
          }}
          disabled={loading}
        />
        {' '}
        Compare cumulative totals for each year
      </label>

      <label htmlFor="date-option2">
        <input
          id="date-option2"
          type="radio"
          name="option"
          value="date"
          checked={option === 'date'}
          onClick={() => setOption('date')}
          disabled={loading}
        />
        {' '}
        Compare cumulative counts as of

        <div className="funnel-report-date-picker-container">
          <DatePicker
            name="date"
            className="form-control form-control-sm"
            disabled={option === 'total' || loading}
            dateFormat={global.I18n.date.formats.default_date_fns}
            selected={date ? parse(date, 'yyyy-MM-dd', new Date()) : null}
            onChange={value => setDate(value ? format(value, 'yyyy-MM-dd') : null)}
          />
        </div>

        <InfoTooltip>Each historical year will be displayed as of this date in the previous year.</InfoTooltip>
      </label>
    </div>
  );
};

FunnelDateSelector.propTypes = {
  date: PropTypes.string,
  setDate: PropTypes.func,

  /** Disables submit button if true */
  loading: PropTypes.bool,
};

FunnelDateSelector.defaultProps = {
  setDate: () => console.log('setDate prop needed'),
  loading: false,
};

export default FunnelDateSelector;
